<p-confirmDialog />
@if (isLoadingData) {
    <div class="flex justify-center">
        <p-progress-spinner ariaLabel="loading" />
    </div>
}
@else {
  @if (ebayProduct) {
    <div class="grid grid-cols-2 gap-2 py-4">
      <div class="col-span-2">
        <app-block-input [(object)]="ebayProduct" class="EbayProduct" property="titre" label="Titre" type="text" [limit]="69" (isSendingData)="sendingDataHandler($event)"></app-block-input>
      </div>
      <div class="col-span-1">
        <app-block-input [(object)]="ebayProduct" class="EbayProduct" property="designation" label="Designation" type="text" (isSendingData)="sendingDataHandler($event)"></app-block-input>
      </div>
      <div class="col-span-1">
        <app-block-input [(object)]="ebayProduct" class="EbayProduct" property="pays_origine" label="Pays d'origine" type="select" (isSendingData)="sendingDataHandler($event)"></app-block-input>
      </div>
      <!-- <div class="col-span-1 flex items-center justify-end gap-4">
        <p-button (click)="updateEbayStocks()" label="M.A.J. Stocks Ebay" icon="pi pi-cart-arrow-down" [loading]="isSendingData" severity="info"/>
        <p-button (click)="regenerateEbay()" label="Regénérer Produit Ebay" icon="pi pi-sync" [loading]="isSendingData" severity="warn" />
      </div> -->
      <div class="col-span-2">
        <app-block-textarea [(object)]="ebayProduct" class="EbayProduct" property="description" label="Description" (isSendingData)="sendingDataHandler($event)"></app-block-textarea>
      </div>
    </div>

    <hr class="!my-0">


    @if (isLoadingSubData) {
        <div class="flex justify-center">
            <p-progress-spinner ariaLabel="loading" />
        </div>
    }
    @if (ebayStocks) {
      <p-accordion>
        @for (ebayStock of ebayStocks; track ebayStock.id) {
            <p-accordion-panel [value]="ebayStock.id">
                <p-accordion-header>
                  <div class="flex grow items-center gap-4 pr-4">
                    <p-tag [severity]="utilityService.getStateSeverity(ebayStock.stock?.etat)" [value]="utilityService.getStateLabel(ebayStock.stock?.etat)" class="my-0.5" />
                    <span class="inline-block px-2 py-1 rounded-sm my-0.5" [class]="utilityService.getSectorClassColor(ebayStock.stock?.secteur?.nom)">{{ ebayStock.stock?.secteur?.nom }}</span>
                    <p-badge badgeSize="small" value="&nbsp;" [severity]="ebayStock.publie ? 'success' : 'danger'" [pTooltip]="ebayStock.publie ? 'Publié sur Ebay' : 'Non publié sur Ebay'" tooltipPosition="bottom" class="ml-auto my-0.5" />
                    <p-button (mousedown)="$event.stopPropagation()" (click)="$event.stopPropagation(); showEbayMarketplace(ebayStock)" type="button" pRipple [text]="true" severity="primary" [rounded]="true" [icon]="'pi pi-shop'" pTooltip="Détail des magasins" />
                    @if (ebayStock.publie) {
                      @if(ebayStock.stock?.url_ebay) {
                        <a [href]="ebayStock.stock?.url_ebay" target="_blank" pButton (mousedown)="$event.stopPropagation()" (click)="$event.stopPropagation()" icon="pi pi-shopping-bag" size="small" [outlined]="true" pTooltip="Lien Ebay" tooltipPosition="bottom"></a>
                      }
                      @else {
                        <span pTooltip="Ebay" tooltipPosition="bottom" class="pi pi-shopping-bag p-1.5 w-8 text-center !text-sm text-surface-500 dark:text-surface-400"></span>
                      }
                    }
                  </div>
                </p-accordion-header>
                <p-accordion-content>
                    <app-product-detail-distribution-ebay-stock [ebayStock]="ebayStock" (ebayStockChange)="onEbayStockChange($event)" (isSendingData)="sendingDataHandler($event)" (needStockReload)="onNeedStockReload()"></app-product-detail-distribution-ebay-stock>
                </p-accordion-content>
            </p-accordion-panel>
        }
      </p-accordion>
    }
  }
  @else {
    <div class="p-4">
      <p-button (click)="generateEbay()" label="Générer Produit Ebay" icon="pi pi-cart-plus" [loading]="isSendingData" />
    </div>
  }
}
